import { trackPromise } from "react-promise-tracker";
import { useQuery } from "react-query";
import { getDashBoardsInfos } from "..";
export const useGetDashboardsInfo = () => useQuery(['GetDashboardInfo'], () => trackPromise(getDashBoardsInfos()), {
    cacheTime: 0
});
